// extracted by mini-css-extract-plugin
module.exports = {"container":"group-button_container__jDNkw","customButton":"group-button_customButton__yVfmq","active":"group-button_active__MmDPk"};